// texts Dict
// SendMoneyMethod
export const manualDetails = {
  credit_card: 'Enter credit card details',
  phone_number: 'Enter recipient’s phone',
  bank_account: 'Enter account details',
  iban: 'Enter recipient’s IBAN',
  customer_id: 'Enter recipient’s ID',
  cpf_cnpj: 'Enter CPF or CNPJ',
  email: 'Enter recipient’s email',
  evp: 'Enter recipient’s EVP',
};
export const manualNames = {
  credit_card: 'Credit card',
  phone_number: 'Phone number',
  bank_account: 'Account number',
  iban: 'IBAN',
  customer_id: 'Customer ID',
  cpf_cnpj: 'CPF/CNPJ',
  email: 'Email',
  evp: 'EVP',
};

export const ListOfFrameWork = {
  otp: 'otp',
  pengine: 'pengine',
  location: 'location',
  clipboard: 'clipboard',
  analytics: 'analytics',
  kpi: 'KPI',
  typingkpi: 'typingkpi',
  translator: 'translator',
  translation: 'translation',
  tooltips: 'toolTips',
  themes: 'theme',
  gif: 'gif',
  sticker: 'sticker',
  stickers: 'stickers',
  promotion: 'promotion',
  promotions: 'promotions',
  typedWords: 'typedWords',
};

export const ListOfBanksName = {
  demoApp: 'DemoApp',
  bv: 'BV',
  bp: 'Banco Popular',
  daviplata: 'Daviplata',
  sbi: 'SBI Ly Hour Bank',
  standardAngola: 'Standard Bank Angola',
};

export const ListOfEngine = {
  paykey: 'paykey',
  rebit: 'rebit',
  both: 'both',
};

export const ListOfLanguage = {
  en_US: 'en_US',
  es_419: 'es_419',
  pt_BR: 'pt_BR',
};

export const credit_card = 'credit_card';
export const phone_number = 'phone_number';
export const bank_account = 'bank_account';
export const iban = 'iban';
export const customer_id = 'customer_id';
export const cpf_cnpj = 'cpf_cnpj';
export const email = 'email';
export const evp = 'evp';

export const enter_details_credit_card = 'enter_details_credit_card';
export const enter_details_phone_number = 'enter_details_phone_number';
export const enter_details_bank_account = 'enter_details_bank_account';
export const enter_details_iban = 'enter_details_iban';
export const enter_details_customer_id = 'enter_details_customer_id';
export const enter_details_cpf_cnpj = 'enter_details_cpf_cnpj';
export const enter_details_email = 'enter_details_email';
export const enter_details_evp = 'enter_details_evp';

export const arrow = 'arrow';
export const magnifying_lens = 'magnifying_lens';
export const recipientVerifyStr = {
  arrow: 'Arrow',
  magnifying_lens: 'Magnifying lens',
};
export const share = 'share';
export const cancel = 'cancel';
export const id_cat = 'id';
export const barcode = 'barcode';
export const custom = 'custom';
export const success_category = 'success';
export const name_category = 'name';
export const icon_category = 'icon';
export const reload_category = 'reload';
export const close_cat = 'close';
export const confirm_cat = 'confirm';
export const today_cat = 'today';
export const balance = 'balance';

export const confirm_close = 'close';
export const confirm_extendStr = 'Example text here for more details, sent by the bank. We display it as is, with this font. \n'
    + 'Just need to be able to put text in a new line.';

export const make_another_transfer = 'make_another_transfer';
export const your_receipt = 'your_receipt';
export const order_send = 'order_send';
export const share_in_chat = 'share_in_chat';
export const share_receipt = 'share_receipt';
export const share_receipt_label = 'share_receipt_label';
export const bill_confirmation_title = 'bill_confirmation_title';
export const copied_now_paste_to_chat = 'copied_now_paste_to_chat';
export const current_account = 'current_account';
export const select_paying_account = 'select_paying_account';
export const select_currency = 'select_currency';
export const account_balance = 'account_balance';
export const select_contact_title = 'select_contact_title';
export const search_contact = 'search_contact';
export const search_contact_hint = 'search_contact_hint';
export const transfer_to_not_on_list = 'transfer_to_not_on_list';
export const no_results = 'no_results';
export const select_recipient_details_type = 'select_recipient_details_type';
export const save_to_contacts = 'save_to_contacts';
export const save_to_list = 'save_to_list';
export const go_account_balance = 'go_account_balance';
export const enable_recipient_validation = 'enable_recipient_validation';
export const recipient_information = 'recipient_information';
export const type_the_barcode = 'type_the_barcode';
export const bill_to_pay = 'bill_to_pay';
export const confirm_payment = 'confirm_payment';
export const pay_now = 'pay_now';
export const payment_day = 'payment_day';
export const payment_date = 'payment_date';
export const insert_another_bill = 'insert_another_bill';
export const search_bank = 'search_bank';
export const search_branch = 'search_branch';
export const how_much_to_transfer = 'how_much_to_transfer';
export const equivalent_to = 'equivalent_to';
export const available_balance = 'available_balance';
export const select_payment_reason = 'select_payment_reason';
export const enter_free_text = 'enter_free_text';
export const select_a_photo = 'select_a_photo';
export const payment_reason = 'payment_reason';
export const make_it_personal = 'make_it_personal';
export const custom_option = 'custom_option';
export const does_it_look_ok = 'does_it_look_ok';
export const face_id_to_approve = 'face_id_to_approve';
export const promo_text_1 = 'promo_text_1';
export const confirmation_sender_label = 'confirmation_sender_label';
export const o_done = 'o_done';
export const go_back_to_menu = 'go_back_to_menu';
export const pay_bill_share_type = 'pay_bill_share_type';
export const share_type = 'share_type';
export const enter_amount_str = 'enter_amount_str';
export const enter_total_amount = 'enter_total_amount';
export const Amount_entered = 'Amount entered';
// Sim_T01_launch_keyboard.js;
export const l_k_title = 'l_k_title';
export const l_k_message = 'l_k_message';
export const l_k_cancel = 'l_k_cancel';
export const got_it = 'got_it';
// Sim_T02_Auth.js;
export const enter_credentials = 'enter_credentials';
export const username = 'username';
export const approve = 'approve';
export const password = 'password';
export const change_id = 'change_id';
export const touch_id_to_approve = 'touch_id_to_approve';
export const enter_your_pin_code = 'enter_your_pin_code';
export const enter_your_password = 'enter_your_password';
export const auth_pin_code_error = 'auth_pin_code_error';
export const enter_the_code_you_just_received = 'enter_the_code_you_just_received';
export const auth_wrong_code_error = 'auth_wrong_code_error';
export const general_error_message = 'General error message';
export const no_connection = 'No connection';
export const transaction_failed = 'Transaction failed';
export const permission_to_photos_str = 'Permission to photos';
export const landscape_not_supported = 'Landscape not supported';

// Sim_T03_Launch_error_messages.js;
export const error_message_general_error = 'error_message_general_error';
export const try_again = 'try_again';
export const error_message_no_connection = 'error_message_no_connection';
export const error_message_transaction_failed = 'error_message_transaction_failed';
export const error_message_landscape_not_supported = 'error_message_landscape_not_supported';
// Sim_T05_Launch_empty_state.js;
export const nothing_to_see_here = 'nothing_to_see_here';
export const your_bills = 'your_bills';
export const Your_Bills = 'Your bills';
export const empty_state_icon = 'empty_state_icon';
// Sim_V01_announcement.js;
export const o_a_title = 'o_a_title';
export const o_a_privacy_policy = 'o_a_privacy_policy';
export const maybe_later = 'maybe_later';
export const o_a_button_title = 'o_a_button_title';
// Sim_V02_promotion.js;
export const promo_text_2 = 'promo_text_2';
export const promo_text_3 = 'promo_text_3';
export const promo_text_4 = 'promo_text_4';
// Sim_V03_instructions.js;
export const o_i_touch_and_hold = 'o_i_touch_and_hold';
export const globe_param = '[globe]';
export const emoji_param = '[emoji]';
export const o_i_step_1_of_2 = 'o_i_step_1_of_2';
export const o_i_enable_bank_keyboard_and = 'o_i_enable_bank_keyboard_and';
export const o_i_your_privacy_title = 'o_i_your_privacy_title';
export const o_i_your_privacy = 'o_i_your_privacy';
export const o_i_take_me_there = 'o_i_take_me_there';
export const o_i_enable_bank_keyboard = 'o_i_enable_bank_keyboard';
export const keyboard_button = 'keyboard_button';
export const onboarding_titleBar = 'onboarding_titleBar';
export const another_keyboard = 'another_keyboard';
export const select_keyboard = 'select_keyboard';
export const other_keyboards = 'other_keyboards';
export const o_i_goto_settings = 'o_i_goto_settings';
export const o_i_tap_keyboards = 'o_i_tap_keyboards';
export const o_i_enable_keyboard = 'o_i_enable_keyboard';
export const o_i_come_back_here = 'o_i_come_back_here';
export const o_i_nanother_time = 'o_i_nanother_time';
export const o_i_step_2_of_2 = 'o_i_step_2_of_2';
export const o_i_switch_to_bank_keyboard_and = 'o_i_switch_to_bank_keyboard_and';
export const o_i_lets_do_it = 'o_i_lets_do_it';
export const o_i_switch_to_bank_keyboard = 'o_i_switch_to_bank_keyboard';
export const o_i_give_it_a_go = 'o_i_give_it_a_go';
export const o_i_tap_the_bank_icon = 'o_i_tap_the_bank_icon';

// Sim_Y02_keyboardPromotion
export const icon_in_the_quick_action_bar_str = 'Icon in the quick action bar';
export const promotion_cards = 'Promotion cards';
export const empty_state_str = 'Empty state';
export const suggested_for_you_str = 'Suggested for you';

// Sim_X01_themeColors.js;
export const transfer_to = 'transfer_to';
export const select_contacts_title = 'Select contacts';
export const confirm_transfer_details = 'Confirm transfer details';
export const enter_amount_title = 'Enter amount';
export const more_details = 'more_details';
export const more_details_label = 'more_details_label';
export const close_label = 'close_label';
export const paid_by = 'paid_by';
export const transaction = 'transaction';
export const fee = 'fee';
export const transaction_fee_is_on_the_recipient = 'transaction_fee_is_on_the_recipient';
export const enable_transaction_fee_on_the_recipient_txt = 'enable_transaction_fee_on_the_recipient';
export const keyboard_screen_example = 'Keyboard screen example';

// Sim_B02_sendMoneySearchResults.js;
export const Bla_bla_bla = 'Bla bla bla|';
export const M_Letter = 'M|';
export const He_Letter = 'He|';
export const Metro_Bank = 'Metro Bank';
// Sim_B06_SendMoneyToAccountManually.js;
export const recipient_name = 'recipient_name';
export const recipient_id = 'recipient_id';
export const bank = 'bank';
export const branch_name = 'branch_name';
export const manual_name = 'manual_name';
export const account_number = 'account_number';
export const recipient_validation = 'recipient_validation';
export const asterisk = '* ';
export const list_options_title = '*List options avilable via API:';
export const list_options_options = '1. Logo image per item of the list\n'
    + '2. A default item can be pre-selected';
/* ;
 Local String;
*/
// MainScreen.js;
export const Reminder_editing_someone_else = "Reminder - you are editing someone else's configuration.\n\nAre you sure you want to save changes?";
export const Reminder_editing_someone_else_send = "Reminder - you are editing someone else's configuration.\n\nAre you sure you want to send?";
export const No_user = 'Error: No user';
export const want_return_to_projects = 'Do you want to return to projects?';
export const want_to_exit = 'Do you want to exit?';
export const Upload_completed = 'Upload completed';
export const Could_not_save_configuration = 'Could not save configuration: ';
export const Save_changes = 'Save changes';
export const Sorry_window_size = 'Sorry - window size too small to display dashboard...\n\nAre you trying to use the app on a phone?';
export const back_str = 'Back';
export const Back_to_projects = 'Back to projects';
export const log_out = 'Log out';
export const yes_str = 'Yes';
export const no_str = 'No';

// AdminScreen.js;
export const can_not_block = 'You can not block/unblock yourself';
export const want_to_unblock = 'Are you sure you want to unblock user?';
export const want_to_block = 'Are you sure you want to block user?';
export const can_not_delete_yourself = 'You can not delete yourself';
export const want_delete_user = 'Are you sure you want to delete user?';
export const PayKey_team = 'PayKey team:';
export const Customers_str = 'Customers:';
export const Add_user = 'Add user';

// LoginScreen.js;
export const enter_valid_username = 'Please enter a valid username\n(4 or more characters)';
export const enter_valid_password = 'Please enter a valid password\n(4 or more characters)';
export const Username_str = 'Username:';
export const Password_str = 'Password:';
export const Remember_me = 'Remember me';
export const login_str = 'Login';
export const stars = '*********';

// Panel_A03_Menu.js;
export const Menu_str = 'Menu';
export const layout_str = 'Layout';
export const menu_design = 'Menu design';
export const top_section = 'Top section';
export const services_section = 'Services section';
export const select_design_service_buttons = 'Select the design of the service buttons';
export const menu_screen = 'Menu screen';
export const Hot_key_str = 'Hot key';
export const Hotkey_QAB_str = 'Hotkey QAB';
export const Disabled_Logo = 'Disabled Logo';
export const iMessage_bar_str = 'iMessage bar';
export const action_bar = 'Action bar';
export const Show_greeting = 'Show greeting';
export const Show_account_balance = 'Show account balance';
export const Select_services_available = 'Services';
export const drag_services_reorder = 'Long press and drag the services to reorder';
export const Save_str = 'Save';
export const NOTE_str = 'NOTE';
export const one_service_enabled = 'Only one service is enabled, meaning this ';
export const screen_skipped = 'screen is skipped';
export const for_customers = ' for customers.';
export const Design_the_layout = 'Design the layout';
export const Select_layout_services = 'Select a layout for the services displayed';
export const Icon_str = 'Icon';
export const instead_of_performing = 'If needed, instead of performing transactions from the keyboard, you can redirect the service to the bank’s app.';
export const Redirect_from_the_keyboard = 'Redirect from the keyboard menu to the bank\'s app';
export const Bars_str = 'Bars';
export const SquareButtons_str = 'Square Buttons';
export const RoundButtons_str = 'Round Buttons';
export const bars_enam = 'bars';
export const square_enam = 'square';
export const round_enam = 'round';
export const Send_money_str = 'Send money';
export const Account_info_str = 'Account info';
export const Request_payment_str = 'Request payment';
export const Split_payment_str = 'Split payment';
export const Service_name = 'Service name';
export const Upload_assets = 'Upload assets';
export const Bank_logo = 'Bank logo';
export const service_icons = 'Service icons';
export const service_action_bar = 'Service icons - Action bar';
export const service_iMessage = 'iMessage service icons';
export const keyboard_menu = 'Keyboard menu';
export const iMessage_menu = 'iMessage menu';
export const Service_icons = 'Service icons';
export const iMessage_str = 'iMessage';
export const Keyboard_menu_str = 'Keyboard menu';
export const add_hot_key_disabled = 'Add Hot key disabled mode';
export const the_services_menu_str = 'The services menu';
export const File_type_keyboard = 'File type: png   File size: 480x120 pixels (@4x)';
export const File_type_iMessage = 'File type: png   File size: 180x135 pixels (@3x)';
// eslint-disable-next-line max-len
export const File_type_service = 'File type: png,  File size: 400x400 pixels (@4x). Per your design, add a border and place the icons on a transparent or colored background.';
// eslint-disable-next-line max-len
export const File_type_str = (FILE_EXT) => `File type: ${FILE_EXT},  File size: 400x400 pixels (@4x). Per your design, add a border and place the icons on a transparent or colored background.`;
export const bank_logo_details = 'File type: PNG. Menu size: 480x120 pixels (@4x) | '
    + 'Keyboard Hot key size: 96x96 pixels (@4x) | iMessage size: 180 × 135 pixels (@3x)';
export const bank_logo_details_qab = 'File type: PNG. Menu size: 480x120 pixels (@4x) | '
    + 'Keyboard Hot key size: 96x96 pixels (@4x) | Hotkey QAB size: 184x184 pixels (@4x) | iMessage size: 180 × 135 pixels (@3x)';
export const action_bar_details = 'File type: PNG. Per your design, add a border, colored background etc.\n'
    + 'File size: 224x184 pixels, radius 60px (@4x).';
export const iMessage_details = 'File type: PNG. Per your design, add a border, colored background etc.\n'
    + 'File size: 400x400 pixels (@4x). ';

// Panel_B01_SendMoneyFrom.js;
export const Select_paying_account = 'Select paying account';
export const where_your_customer_selects = 'Your customer can click on the account balance in the previous screen, '
    + 'and change the account from which the payment will be made.'
    + ' \n\n'
    + 'If your customer has only one account, this option won’t be available and they won’t see this screen.';
// eslint-disable-next-line max-len
export const your_customer_can_click = 'Your customer can click on the account balance in the previous screen, and change the account to which the payment will be transfered.\n\n'
    + 'If your customer has only one account, this option won’t be available and they won’t see this screen.';
export const Asset_requirements = 'Asset requirements';
export const Asset_requirements_paragraph = 'To show an icon near each account, you should send icons dynamically per account type via API,'
    + ' including a placeholder icon for loading and connectivity issues.';
export const use_proprietary_icons = 'You can use proprietary icons per account type, sent via API.';
// eslint-disable-next-line max-len
export const show_an_icon_each_bill = 'To show an icon for each bill, you should send icons dynamically via API, including a placeholder icon for loading and connectivity issues.';
export const File_type_svg = 'File type: svg\nFile size: 20px by 20px\nColor: Same as main font color';
export const File_type_pay_bill = 'File size: 20x20 pixels';
export const File_success_image_spec = 'File type：.png   File size: 270x100 pixels at 400%';

// Panel_B02_SendMoneyRecipientList.js;
export const Recipient_list = 'Recipient list';
export const Add_recipient_manually_icon = 'Add recipient manually - icon';
export const Enable_customers_to_select = 'Enable customers to select a payment recipient from a list.';
export const Customer_can_select = 'Customer can select recipient from a list';
export const Set_avatar_design = 'Set avatar design';
export const Display_recipient_avatars = 'Display recipient avatars';
export const Select_colors_applied = 'Select the colors that will be applied to avatars in the list.';
export const If_recipient_disabled = 'If the recipient list is disabled your customer will only be able to manually add a payment recipient.';
export const recipient_disabled_add_manually = 'If the recipient list is disabled your customers will skip this step and only'
    + ' be able to add a recipient manually. Configure manual options in the next step.';
export const when_disabling_request = 'When disabling the request from a specific recipient, your customer will receive a generic link to share.';
export const avatar_color_1 = 'avatar_color_1';
export const avatar_color_2 = 'avatar_color_2';
export const avatar_color_3 = 'avatar_color_3';
export const avatar_color_4 = 'avatar_color_4';
export const SkipContactScreen = {
  plus_sign: 'Plus sign',
  contact: 'Contact',
};

// Panel_B02_SendMoneySearchResults.js;
export const No_results_image = 'No results image';
export const File_type_image = 'File type: PNG.  File size: 1080 x 280 pixels (@4x).';
export const phone_number_no_spaces = '54012345678|';
export const transfer_to_link = 'Transfer to 54012345678';
export const so_str = 'So|';

// Panel_B03_SendMoneyTransferMethod.js;
export const must_have_one = 'You must have at least one method selected';
export const Manual_recipient_options = 'Manual recipient options';
export const Banco_BV = 'Banco BV';
export const Select_manual_transfer = 'Select which manual transfer method will be available to customers.';
export const drag_methods_reorder = 'Long press and drag the methods to reorder';
export const one_selection_enabled = "When only one selection is enabled (recommended), your customers won't see this "
    + 'screen and will skip directly to the next step.';

// Panel_B05_SendMoneyTransferMethod.js;
export const Arrow_str = 'Arrow';
export const magnifying_lens_str = 'Magnifying lens';
export const add_contact_name_str = 'add_contact_name_str';
export const add_contact_name_note = 'Add \'Contact name\' field when saving';
// Panel_B07_SendMoneyToIBANManually.js;
export const Add_recipient_validation_step = 'Add recipient validation step';

// Panel_B08_SendMoneyAmount.js;
export const Transfer_amount = 'Transfer amount';

// Panel_J01_LoanUpdateAmount.js;
export const Update_amount_title = 'Update Amount';

// Panel_J02_LoanNumberInstallments.js;
export const Number_of_installments = 'Number of installments';
export const Enter_number = 'Enter number';
export const Configure_screen_number = 'Configure the screen where your customer sets the number of installments.\n'
  + 'Instructions, error messages, currency options & conversion  should be sent dynamically via API.';

// Panel_J03_LoanSelectSource.js;
export const Select_loan_source = 'Select loan source';
export const Customer_select_source = 'This is where your customer selects the source from which the transaction will be made.';
export const Icon_dynamically = 'You can send icon dynamically per account type via API.';
export const Available_withdrawal = 'Available withdrawal limit - Cash: $50\ninstallments: $150.\nInvoice payment: 29 Jun.\n'
  + 'Best shopping day:\n20/06.';
export const File_type_recommended = 'File size: 42x130 pixels\n'
  + 'Recommended color:  same as Tertiary font defined in the Theme section, to match all other icons across the app.';

// Panel_J04_LoanInstallmentOptions.js;
export const installment_options_title = 'Installment options';
export const select_installment_option = 'Select installment options';
export const installment_options_layout = 'Installment options layout';
export const configure_screen_option = 'Configure the screen where your customer sets the amount of the installments.';
export const installmentOptionsList = ['1X $50.20', '2X $100.50', '3X $250.00', '4X $300.30', '5X $500.80'];
export const installment_options_column_key = {
  column_1: 'column_1',
  column_2: 'column_2',
};
export const installment_options_column_text = {
  column_1: '1 column',
  column_2: '2 column',
};
export const installment_options_alignment_key = {
  left: 'left',
  center: 'center',
};
export const installment_options_alignment_text = {
  left: 'Content aligned left',
  center: 'Content centered',
};

// eslint-disable-next-line max-len
export const To_show_an_icon = 'To show an icon near each account, you should send icons dynamically per account type via API, including a placeholder icon for loading and connectivity issues.';
export const File_type = 'File size: 48x48 pixels';
export const amount_in_multiplies = 'Please enter an amount in multiplies of $10.0000';
export const Equivalent_to_KHR = 'Equivalent to KHR 203,500.00';
export const enter_between = 'Enter between $10.000 and $720.000';
export const Enter_amount = 'Enter amount';
export const Error_message = 'Error message';
export const Multiple_currencies = 'Multiple currencies';
export const Change_currency = 'Change currency';
export const Change_paying_account = 'Change paying account';
export const QR_not_valid = 'The QR code you scanned is not valid.';
export const Enter_manually_scan_barcode = 'Enter manually or scan barcode';
export const Choose_method = 'Choose method';
export const Configure_screen_amount = 'Configure the screen where your customer sets the amount of the transfer.\n\n'
    + 'Instructions, error messages, currency options & conversion  should be sent dynamically via API.';
export const Enable_convert_currency = 'Enable convert to non-local currency';
export const show_Balance = 'Show account balance';
export const Enable_additional_instructions = 'Enable additional instructions, convert currency, etc.';

export const Text_elements_API = 'Text elements sent via API (here for reference only)';

// Panel_B09_SendMoneyReference.js;
export const Allow_customers_add_reason = 'Allow customers to add a reason or reference for the transfer.';
export const Enable_customers_add_reason = 'Enable customers to add a reference for the transfer';
export const Enable_customers_add_photo = 'Enable customers to add a photo';
export const Customers_write_reason = 'Customers can write a custom reason';
export const disabled_customer_will_skip = 'If disabled your customer will skip this step and move directly to the next screen.';
export const Design_layout = 'Design layout';
export const Select_reason = 'Select reason from options';

// Panel_B10_SendMoneyConfirmation.js;
export const Transfer_confirmation = 'Transfer confirmation';
export const Select_fields_appear = 'Select the fields that appear in the transfer confirmation screen.';
export const Price_100 = '$100.00';
export const two_hundred_dollars = '$200.00';
export const Show_transaction_details = 'Show transaction details';
export const Thanks_for_your_help = 'Thanks for your help';
export const Phone_number_str = '(520)-405-3515';
export const Service_fee_recipient = 'Service fee $1 on recipient';
export const Your_account_str = 'Your account';
export const Bank_1234567_8 = '1234567-8';
export const Bank_123456_78 = '123456-78';
export const num_3452562 = '3452562';
export const Current_account_123 = 'Current account | 123456-78';
export const orOperator_123456_78 = ' | 123456-78';
export const Bank_520_4073_10 = '520-4073-10';
export const Date_09_08_2020 = '09/08/2020';
export const Bank_name_str = 'Happy bank';
export const Phone_str = 'Phone';
export const phone_number_one = '1234 567 890';
export const phone_number_zero = '012 3456 789';
export const Or_enter_other_amount = 'Or enter other amount';
export const Type_one = 'Type one';
export const Type_two = 'Type two';
export const transaction_fee_paid = 'Transaction fee paid by recipient';

// Panel_H08_TopUpSelectOperator.js
export const select_operator_title = 'Select operator';
export const select_operator_paragraph = 'Enable customers to select a mobile operator';
export const select_operator_switch = 'Customer should select a mobile operator';
export const select_operator_layout_title = 'Design the layout';
export const select_operator_asset_note = 'To show a logo for each operator, you should send icons dynamically via API, '
    + 'including a placeholder icon for loading and connectivity issues.';
export const select_operator_asset_size = 'File size: 48x48 pixels (@1x)';
export const select_operator_layout_key = {
  column_1: 'column_1',
  column_2: 'column_2',
};
export const select_operator_layout_text = {
  column_1: '1 column',
  column_2: '2 column',
};

// Panel_H08_TopUpSelectPackage.js
export const select_package_title = 'Top up amount';
export const select_package_subtitle = 'Select a package';
export const select_package_paragraph = 'Configure the screen where your customer sets the amount to top up.';
export const select_package_layout_title = 'Packages layout';
export const manual_amount_layout_title = 'Manual amount layout';
export const plans = 'Plans';
export const manual_amount = 'Manual amount';
export const select_package_configuration_key = {
  packages: 'packages',
  manual_amount: 'manual_amount',
  both: 'both',
};
export const select_package_configuration_text = {
  packages: 'Packages',
  manual_amount: 'Manual amount',
  both: 'Both',
};
export const select_package_layout_columns_text = {
  column_1: '1 column',
  column_2: '2 column',
  column_3: '3 column',
};
export const design_the_layout_key = {
  column_1: 'column_1',
  column_2: 'column_2',
  column_3: 'column_3',
};
export const select_package_layout_aligned_text = {
  left_aligned: 'Content aligned left',
  center_aligned: 'Content centered',
};

export const select_package_layout_aligned_key = {
  left_aligned: 'left_aligned',
  center_aligned: 'center_aligned',
};

export const packageList = [{
  title: 'XTRA COMBO',
  amount: '20$',
  details: 'Internet quota of 270-750MB (based on zone), \nvalid for 7 days.',
},
{
  title: 'VIP COMBO',
  amount: '25$',
  details: 'Internet quota of 270-750MB (based on zone), \nvalid for 7 days.',
},
{
  title: 'XTRA COMBO PLUS',
  amount: '30$',
  details: 'Internet quota of 270-750MB (based on zone), \nvalid for 7 days.',
},
{
  title: 'Family plan',
  amount: '80$',
  details: 'Internet quota of 270-750MB (based on zone), \nvalid for 7 days.',
},
{ title: 'Plan 5', amount: '120$', details: 'Internet quota of 270-750MB (based on zone), \nvalid for 7 days.' },
{ title: 'Plan 5', amount: '120$', details: 'Internet quota of 270-750MB (based on zone), \nvalid for 7 days.' }];

// Sim_H08_TopUpSelectOperator.js
export const select_operator_without_sim = 'Operators without logos';
export const select_operator_with_sim = 'Operators with logos';
export const operatorsList = ['T-Mobile', 'Beeline', 'Turkcell', 'Beeline', 'Vodafone'];

// Amount
export const number_0_00 = '0.00';
export const number_35_00 = '35.00';
export const number_50_00 = '50.00';
export const Dollar_50 = '$50';
export const Dollar_50_00 = '$50.00';
export const Dollar_100 = '$100';
export const Dollar_79_29 = ' $79.29';
export const Dollar_300 = '$300';
export const Dollar_500 = '$500';
export const Dollar_35000 = '$35,000.00';

// Panel_B12_SendMoneySuccess.js;
export const Transfer_success = 'Transfer success';
export const Select_customize_fields = 'Select and customize the fields in this screen.';
export const text_message_str = 'text_message';
export const shareMethod = {
  text_message: 'Text message (Copy to clipboard)',
  receipt: 'Receipt (Open and share file)',
};
export const shareMethodKeys = {
  text_message: 'Text message',
  receipt: 'Receipt',
};

// Panel_B13_SendMoneyChangeOrder.js;
export const All_screens = 'All screens:';
export const Save_new_order = 'Save new order';
export const custom_screen_UI = 'This is a custom screen. The UI and configuration here will be done by the developers in the app itself.';

// Panel_C02_AccountInfoBalance.js;
export const Account_balance = 'Account balance';
export const SMS_sent = 'SMS sent!';
export const Confirm_action = 'Confirm action';
export const Transaction_details_two_action = 'Transaction details & 2 actions';
export const Transaction_details_one_action = 'Transaction details & 1 action';
export const Action_success = 'Action success';
export const Resend_SMS = 'Resend SMS';
export const Configure_customer_sees = 'Configure how your customer sees their account balance.';
export const Recent_account_transactions = 'Recent transactions';
export const Review_customer_sees = 'Configure how your customers see their recent account transactions.';
export const More_details_per_transaction = 'Enable customers to view more details per transaction';
export const Show_link_transactions_list = 'Show a link to the updated transactions list when done';
export const Recipient_str = 'Recipient';
export const Amount = 'Amount';
export const Transaction_pending = 'The transaction is pending for more than 24h. You can resend SMS with the payment request or cancel the transaction.';
export const Trx_ID = 'Trx. ID';
export const Trx_date = 'Trx. date';
export const Trx_ID_number = '1234567890123456';
export const Account_number_number = '123 456 789';
export const Trx_date_number = '06/08/2021 08:15:31';
export const Account_number = 'Account number';
export const Account_name = 'Account name';
export const CBS_ID = 'CBS ID';
export const CBS_ID_number = '123456789000000';
export const Cancel_transfer = 'Cancel transfer';
export const Amazon = 'Amazon';
export const Cash_back = 'Cash back';
export const Date_28_8_2021 = '28/8/2021';
export const Date_27_8_2021 = '27/8/2021';
export const Date_25_8_2021 = '25/8/2021';
export const Time_11_00 = '11:00';
export const Time_17_00 = '18:45';
export const Time_9_32 = '9:32';
export const Saturday_28_Aug = 'Saturday, 28 Aug';
export const Yesterday = 'Yesterday';
export const Pending_9_32 = '9:32  |  Pending';
export const Price_minus_34_87 = '- $34.87';
export const Price_minus_750 = '- $750.00';
export const Price_12_50 = '$12.50';
export const Exclamation_mark = '!';

// Panel_D01_PayBillsBillsList.js;
export const Bills_list = 'Bills list';
export const select_a_Bills = 'Select a bill';
export const Add_new_bill = 'Add new bill';
export const where_customer_sees = 'This is where your customer sees their upcoming bills.';
export const Enable_customers_enter = 'Enable customers to enter a bill code manually';
export const Scan_barcode_android = 'Enable customers to scan barcode\n(android only)';
export const Show_account_balance_inc = 'Show account balance (inc. change account)';
export const Select_a_bill = 'Select a bill';
export const where_customer_enter = 'This is where your customer can scan a bill barcode, or enter manually a bill code they wish to pay.';
export const where_customer_selects = 'This is where your customer selects the account from which the bill will be paid.'
    + '\nIf your customer only has one account, they won’t see this screen and will go directly to the next screen.';
export const Bill_confirmation = 'Bill confirmation';
export const Configure_bill_confirmation = 'Configure the bill confirmation screen. Most of the data is sent via API, and displayed as in this example.';
export const Allow_customers_change = 'Allow customers to change the payment date';
export const Payment_date = 'Payment date';
export const Bill_payment_success = 'Bill payment success';
// eslint-disable-next-line max-len
export const Your_customer_can_click_account_balance = 'Your customer can click on the account balance in the previous screen, and change the account from which the payment will be made.\n\n'
    + 'If your customer has only one account, this option won’t be available and they won’t see this screen.';
export const Your_customer_can_click_new_bill = 'Your customer can click on add new bill in the previous screen, and choose which method to use.'
    + '\n\nIf scan barcode option is enabled, both methods will appear.'
    + '\n\nIf disabled, only the manual method will appear.The option for barcode scanning is only available on Android devices.';

// Panel_T01_launch_keyboard.js;
export const launch_keyboard_app = "To launch the keyboard app, your customer clicks the bank icon on the top left of their phone's keyboard.";
export const Show_welcome_message = 'Show the welcome message on iOS devices';
export const WARNING_str = 'WARNING:';
export const highly_recommend_welcome = 'We highly recommend enabling the welcome message, which increases the chances '
    + 'of your iOS app being approved by Apple, by explaining to the user how they can use their new keyboard.';
export const HotKey_Logo = 'HotKey Logo';
export const Add_disabled_mode = 'Add disabled mode';
export const File_type_recommended_area = 'File type: png  File size: 40x40 pixels. Recommended image area:'
    + '\nMinimum 24x24, less than 40x40 pixels (height of the suggestion bar).';

// Panel_T02_launch_auth.js;
export const authentication_transactions = 'Since the authentication in transactions is disabled, authentication upon '
    + 'launch must be enabled.\n\nDo you want to change when customers authenticate? ';
export const authentication_upon_launch = 'Since the authentication upon launch is disabled (recommended), '
    + 'authentication to approve transactions must be enabled.\n\nDo you want to change when customers authenticate? ';
export const Authentication_str = 'Authentication';
export const Configure_customers_transactions = 'Configure how your customers approve transactions and access their personal data.';
export const Enable_authentication_launch = 'Enable authentication* upon launch';
export const Enable_authentication_transactions = 'Enable authentication to approve transactions';
export const View_account_info = 'View account info';
export const Pay_bills_str = 'Pay bills';
export const Single_authentication_recommended = 'Single authentication instance is recommended to create a streamlined user experience.'
    + '\n\nAuthentication to approve transactions happens later in the '
    + 'customer journey, usually resulting in higher engagement.';
export const Additional_configuration_API = 'Additional configuration can be sent via API';
export const Additional_configuration_API_list = [
  '• Hint to PIN code: Display hint by default or link to hint in the error message.',
  '• Switch to code authentication after [x] biometric authentication fails.',
  '• Username formatting.'];
// export const Hint_PIN_code = '• Hint to PIN code: Display hint by default or link to hint in the\n  error message.\n\n• '
//     + 'Switch to code authentication after [x] biometric authentication fails.\n\n• Username formatting.';
export const Available_authentication_methods = '*Available authentication methods';
export const Available_authentication_methods_list = [
  'Biometric: Face ID (iOS only) or Fingerprint', 'Username & Password', 'PIN code', 'Password', 'OTP',
];
export const Switch_authentication = 'Switch authentication';

//  Panel_T03_launch_error_messages
export const configure_the_error_messages = 'Configure the error messages for all the interaction use cases.';
export const General_error = 'General error';
export const No_connection = 'No connection';
export const Transaction_failed = 'Transaction failed';
export const permission_to_photos_two_lines = 'Permission to \nphotos';
export const Landscape_error = 'Landscape error';
export const description_upload = 'File type: PNG. File size: 270x150 pixels at 400%';

// Panel_T05_launch_empty_state.js
export const empty_state_title = 'Empty state';
export const empty_state_paragraph = 'Configure the empty state appearance for cases in which there’s no data to show';

// Panel_T06_launch_iMsgExpandTexts.js;
export const Expand_message = 'Expand message';
export const Configure_the_message = 'Configure the message for cases in which the Half-height is too small, and Expand mode must be used to see the content.';

// Panel_V01_announcement.js
export const keyboard_announcement_title = 'Keyboard announcement';
export const keyboard_announcement_paragraph = 'Configure the keyboard onboarding flow SDK, which includes an announcement and set up instructions. '
    + 'It will appear as part of the bank app\'s update.';
export const keyboard_announcement_switch_activation = 'Enable and configure keyboard activation flow';
export const keyboard_announcement_sub_title = 'Set screen design';
export const keyboard_announcement_switch_privacy_link = 'External link to terms or more information';
export const Announcement_icon = 'Announcement icon';
export const keyboard_announcement_WARNING = 'Activation and onboarding step is skipped. \n'
    + 'We recommend using Paykey\'s walk-through keyboard activation.';

// Panel_V02_KeyboardPromotionalScreens.js
export const keyboard_promotional_screens = 'Keyboard promotional screens';
export const select_promotional_screens = 'Select 3 of 4 promotional screens, available to customers by swiping the announcement to learn more about the'
    + ' keyboard.\n\nThe content is fully customized based on your preferences in previous steps.';
export const promotional_screen_menu = 'Promotional screen #2: Menu';
export const Automatic_defined_services = 'Automatic - defined services';
export const Upload_image = 'Upload image';
export const promotional_screen_3 = 'Upload Promotional screen #3';
export const screens_automatically_added = 'Screens 1 & 2 are automatically added. The additional 3rd screen content is up to you. Select one of these:';
export const security_str = 'Security';
export const stickers_gifs = 'Stickers & GIFs';
export const Stickers_str = 'Stickers';
export const Sticker_row_small = 'Sticker row (small)';
export const file_type_stickers = 'File type: PNG.\n'
    + 'File size: (Stickers)304x100/(Sticker row)256x24 pixels at 400%';

// Panel_V03_EnableTheKeyboard.js
export const enable_the_keyboard = 'Enable the keyboard';
export const allow_full_access = 'The customer must enable the keyboard in the phone’s settings and allow full access, in order to start using it.';
export const come_back_icon_ios = '“Come back” icon (iOS)';
export const success_icon = '“Success” icon';
export const success_open_keyboard_with_interaction = 'Success: open keyboard with interaction message';
export const file_type_icon = 'File type: PNG.\n'
    + 'File size: (Come back)32x40/(Success)300x100 pixels at 400%';

// Panel_X01_themeColors.js;
export const want_reset_all_properties = 'Do you want to reset all properties to default values?';
export const Colors_str = 'Colors';
export const Style_str = 'Style';
export const Design_the_elements = 'Design the elements';
export const Select_style_elements = 'Select a style for the elements corners';
export const Set_appearance_brand = 'Set the appearance of the app to match your brand guidelines';
export const colorsName = {
  primary_font_color: '1. Primary font',
  secondary_font_color: '2. Secondary font',
  tertiary_icons_color: '3. Tertiary font',
  cta_font_color: '4. CTA font',
  links_icons_color: '5. Link & icons',
  menu_primary_color: '6. Menu primary',
  menu_secondary_color: '7. Menu secondary',
  primary_cta_color: '1. Brand primary',
  disabled_cta_color: '2. CTA disabled',
  pressed_cta_color: '3. CTA pressed',
  border_color: '4. Border',
  border_light_color: '5. Lighter border',
  light_elements_color: '6. Light elements',
  menu_top_area_color: '7. Menu top area',
  menu_balance_color: '8. Menu balance',
  app_background_color: '9. App background',
  positive_color: '10. Positive',
  negative_color: '11. Negative',
};
export const Font_colors = 'A. Font colors';
export const Primary_font_A1 = '1. Primary font';
export const Secondary_font_A2 = '2. Secondary font';
export const Tertiary_font_A3 = '3. Tertiary font';
export const CTA_font_A4 = '4. CTA font';
export const Link_icons_A5 = '5. Link & icons';
export const Menu_primarty_A6 = '6. Menu primary';
export const Menu_secondary_A7 = '7. Menu secondary';
export const Brand_font_B1 = '1. Brand primary';
export const CTA_disabled_font_B2 = '2. CTA disabled';
export const CTA_pressed_font_B3 = '3. CTA pressed';
export const Border_font_B4 = '4. Border';
export const Lighter_border_B5 = '5. Lighter border';
export const Light_elements_B6 = '6. Light elements';
export const Menu_top_area_B7 = '7. Menu top area';
export const Menu_balance_B8 = '8. Menu balance';
export const App_background_font_B9 = '9. App background';
export const Positive_font_B10 = '10. Positive';
export const Negative_font_B11 = '11. Negative';
export const Elements_background_colors = 'B. Elements & background colors';
export const Reset_all_colors = 'Reset all colors';
export const primary_font_color = 'primary_font_color';
export const secondary_font_color = 'secondary_font_color';
export const tertiary_icons_color = 'tertiary_icons_color';
export const cta_font_color = 'cta_font_color';
export const links_icons_color = 'links_icons_color';
export const menu_primary_color = 'menu_primary_color';
export const menu_secondary_color = 'menu_secondary_color';
export const primary_cta_color = 'primary_cta_color';
export const disabled_cta_color = 'disabled_cta_color';
export const pressed_cta_color = 'pressed_cta_color';
export const border_color = 'border_color';
export const border_light_color = 'border_light_color';
export const light_elements_color = 'light_elements_color';
export const menu_top_area_color = 'menu_top_area_color';
export const menu_balance_color = 'menu_balance_color';
export const app_background_color = 'app_background_color';
export const positive_color = 'positive_color';
export const negative_color = 'negative_color';

// Panel_X01_themeRadius.js
export const Square_corners = 'Square corners';
export const Round_corners = 'Round corners';

// Panel_X02_themeFonts.js
export const Font_str = 'Font: ';
export const Fonts_str = 'Fonts';
export const Regular_str = 'Regular';
export const Font_Regular = 'Font: Regular';
export const Bold_str = 'Bold';
export const Font_Bold = 'Font: Bold';
export const File_type_font = 'File types: ttf or otf';
export const Set_font_app = 'Set the font of the app to match your brand guidelines';
// eslint-disable-next-line max-len
export const In_ios_and_android = ' In iOS, uploading your own font will affect ONLY the onboarding screens. The font of the keyboard screens will remain iOS system font due to size limitations.\n\n'
    + 'In Android your brand font will apply to both the onboarding and the keyboard screens.';
export const Important_note = 'Important Note:';
export const Font_android_only = 'Use custom font in the keyboard (Android only)';
export const Font_android_ios = 'Use custom font in iOS & Android onboarding screens';

// Sim_B06_SendMoneyToAccountManually.js;
export const inputTestManual = {
  credit_card: '4590-3123-6582-5103',
  phone_number: '054-1234567',
  bank: 'Momoji',
  iban: 'NO 93 8601 1117947',
  cpf_cnpj: '099.987.986-96',
  email: 'email@paykey.com',
  evp: 'df932rfas0f2vdsfw2dsvj92r2fdfvd',
  recipient_id: '**********',
  recipient_name: 'Sophie Davis',
  branch_name: 'Head office branch',
  bank_account: '1234567',
  add_contact_name: 'Sophie Davis',
  customer_id: '546983526450',
};

export const ManualName = {
  credit_card: 'creditCard',
  phone_number: 'phoneNumber',
  bank_account: 'accountNumber',
  iban: 'iban',
  cpf_cnpj: 'cpfCnpj',
  email: 'email',
  evp: 'evp',
  customer_id: 'customerId',
};

export const actionPathManual = {
  credit_card: 'creditCardPath',
  phone_number: 'phoneNumberPath',
  bank_account: 'accountNumberPath',
  iban: 'ibanPath',
  cpf_cnpj: 'cpfCnpjPath',
  email: 'emailPath',
  evp: 'evpPath',
  customer_id: 'customerIdPath',
};

export const show_bank_search_filled_text = 'Banco do Brasil';

export const bank_name_1 = 'Caixa';
export const bank_name_2 = 'Momiji Bank';
export const bank_name_3 = 'Monzo';
export const bank_name_4 = 'Jalgaon';
export const bank_name_5 = 'Adayar';
export const bank_name_6 = 'Ahmedabad - Bapu Nagar';
export const bank_name_7 = 'Ahmedabad - Gandhi Nagar';
export const bank_name_8 = 'Headquarters branch';
export const bank_name_9 = 'Hempstead';
export const bank_name_10 = 'Bradesco';

export const Both = 'Both';
export const Android = 'Android';
export const iOS = 'iOS';
export const iMessage = 'iMessage';

export const share_transaction_button = 'share_transaction_button';
export const enable_make_another_transfer = 'enable_make_another_transfer';
export const text_message = 'Text message';
export const search_from_list = 'Search from list';
export const Free_text = 'Free text (No list)';
export const Validation_icon = 'Validation icon';
export const please_enter_screen_name = 'Please enter a screen name';
export const please_enter_service_name = 'Please enter a service name';
export const edit_order = 'Edit order';
export const name_already_exists = 'Screen name already exists';
export const edit_screen_name = 'Edit screen name';
export const Search_results = 'Search results';
export const Sharing_method = 'Sharing method';
export const screen_name = 'Screen name';
export const enter_screen_name = 'Enter screen name';
export const text_message_pasted = 'Text message (Pasted to chat)';
export const Receipt_Open_share = 'Receipt (Open and share file)';
export const cancel_str = 'Cancel';
export const delete_str = 'Delete';
export const Are_you_sure = 'Are you sure?';
export const Once_delete_service = 'Once you delete the service ';
export const its_gone_for_good = ', it’s gone for good.';
export const launch_keyboard = 'Launch keyboard';
export const confirm_str = 'Confirm';
export const configure_settings_manually = 'Configure the settings for manually adding a recipient.';
export const stand_alone_step = 'As a stand alone step';
export const add_a_screen = 'Add a screen';
export const Duplicate_a_service = 'Duplicate a service';
export const Give_it_name = 'Give it a name';
export const add_screen = 'Add screen';
export const ok_str = 'Ok';
export const must_have_one_service = 'You must have at least one service selected';
export const show_account_info_Auth = "To show account info you will need to enable 'Auth upon tapping the bank icon'\n\nDo you want to enable?";
export const where_your_customer_search = 'This is where your customer can search their list of recipients.';
export const Configure_main_screen = 'Configure the main screen of your keyboard, where your customers choose the actions they want to take.';
export const Theme_str = 'Theme';
export const Services_str = 'Services';
export const Send_form = 'send_form';

export const theme_category = 'theme';
export const services_category = 'services';
export const launch_category = 'launch';
export const deliverables_category = 'deliverables';
export const onboarding_category = 'onboarding';
export const send_category = 'send';
export const keyboard_category = 'keyboard';
export const development_category = 'development';
export const delete_type = 'Delete type';
export const Add_type_str = ' Add type...';

export const Interaction_str = 'Interaction';
export const Deliverables_str = 'Deliverables';
export const Onboarding_str = 'Onboarding';
export const Keyboard_str = 'Keyboard';
export const development_str = 'Development';
export const Send_str = 'Send';
export const Next_str = 'Next';
export const next_category = 'next';
export const reason_str = 'reason';
export const Block_user = 'Block user';
export const Unblock_user = 'Unblock user';
export const Allow_customer_save_recipient = 'Allow customer to save recipient to list';
export const Edit_text_elements = 'Edit text elements';
export const Please_select_file = 'Please select a .ttf or .otf file';
export const Please_select_a = 'Please select a .';
export const file_str = ' file';
export const Upload_str = 'Upload';
export const Rent_str = 'Rent';
export const Expenses_str = 'Expenses';
export const Fee_str = 'Fee';
export const Family_str = 'Family';
export const Birthday_str = 'Birthday';
export const Thanks_for_dinner_str = 'Thanks for dinner';
export const Step_1_Enter = 'Step 1: Enter details';
export const Step_1_main = 'Step 1: Main screen';
export const Step_2_Show = 'Step 2: Show contact name';
export const Step_2_select = 'Step 2: select a reason';
export const select_a_reason = 'Select a reason';
export const select_a_photo_str = 'Select a photo';
export const Upload_photo_from_device = 'Upload a photo from device';
export const enter_a_custom_reason = 'Enter a custom reason';
export const Step_2_Verify = 'Step 2: Verify recipient details';
export const Step_2_Enter = 'Step 2: Enter contact name';
export const Step_3_Enter = 'Step 3: Enter contact name';
export const Step_3_enter = 'Step 3: enter custom reason';
export const Enter_bank_name = 'Enter bank name';
export const Enter_branch_name = 'Enter branch name';
export const Main_screen = 'Main screen';
export const Default_confirmation_screen = 'Default confirmation screen';
export const Recipient_details_open = 'Recipient details open (if sent)';
export const Pasted_to_chat = 'Pasted to chat';
export const View_receipt_top = 'View receipt - top';
export const View_receipt = 'View receipt';
export const Transfer_money = 'Transfer money';
export const DATA_STR = 'Today, 07/11/2020 at 12:15:09';
export const Payment_amount = 'Payment amount';
export const money_amount = 'R$ 1.199,00';
export const Onboarding_example = 'Onboarding example';
export const banks_keyboard = "[bank]'s keyboard";

export const hashtag = '#';
export const success_str = 'Success!';
export const Success_screen = 'Success screen';
export const Success_screen_simple = 'Success screen - simple';
export const Success_screen_more_info = 'Success screen - with more info';
export const sent_100_to_Sophie = 'You’ve sent $100 to Sophie. She will see it in her account shortly.';

export const welcome_Text = 'Good [time of day] [first name]';
export const creditCardCodeNumber = '**** **** **** 1234';
export const creditCardPhoneNumber = '560-5224-2254';
export const initialsName = 'PL';
export const primaryLine = 'Primary Line';
export const secondaryLine = 'Secondary Line';

export const userInitialsNameSD = 'SD';
export const userNameSD = 'Sophie Davis';
export const userInitialsNameGM = 'GM';
export const userNameGM = 'Gabriel Moreira';
export const userInitialsNameCB = 'CB';
export const userNameCB = 'Carmen Beltrán';
export const userInitialsNameDK = 'DK';
export const userNameDK = 'Dana Kopřivová';
export const userInitialsNameLZ = 'LZ';
export const userNameLZ = 'Lu Zhou';
export const userInitialsNameSR = 'SR';
export const userNameSR = 'Sophie Richards';
export const userInitialsNameSM = 'SM';
export const userNameSM = 'Sophie Moore';
export const userNameMS = 'Marlene Simmons';
export const contactListName = [
  { userInitialsName: userInitialsNameSD, userName: userNameSD },
  { userInitialsName: userInitialsNameGM, userName: userNameGM },
  { userInitialsName: userInitialsNameCB, userName: userNameCB },
  { userInitialsName: userInitialsNameDK, userName: userNameDK },
  { userInitialsName: userInitialsNameLZ, userName: userNameLZ },
  { userInitialsName: userInitialsNameSR, userName: userNameSR },
  { userInitialsName: userInitialsNameSM, userName: userNameSM }];

export const userNameIU = '12282938-9 Itaú Unibanco';
export const userAddress = 'Nu Pagamentos S.A.';
export const creditCardNumber = 'xxx.555.444.xx';
export const Scheduled_for = 'Scheduled for';
export const Scheduled_data = '12/11/2020';
export const Paying_account = 'Paying account';
export const Payment_account = 'Payment account';
export const Bills_code = "Biil's code";
export const long_send_money_number = '23793.38128 60012.289017 86000.063304 9 80 390000010000';
export const Authentication_code = 'Authentication code';
export const long_send_money_code = '5d8a52c4-9bar-65a3-a386-cfaea8';
export const View_receipt_bottom = 'View receipt - bottom';
export const Paste_receipt_chat = 'Paste receipt in chat';
export const Copy_receipt_clipboard = 'Copy receipt to clipboard';
export const Share_dialog = 'Share dialog';
export const receipt = 'receipt';

// Account Info;
export const current_account_str = 'Current account';

// Account Info Balance;
export const e_wallet = 'e-wallet';
export const credit_card_str = 'Credit card';
export const creditCardCodeNumber1 = '•••• •••• •••• 8640';

// Account Info In Out;
export const Default_view = 'Default view';
export const Default_view_indication = 'Default view with indication';
export const Multiple_accounts_categories = 'Multiple accounts & categories';
export const Swipe_multiple_accounts = 'Swipe multiple accounts';
export const Multiple_accounts = 'Multiple accounts';
export const Grouped_transactions = 'Grouped transactions';
export const money_amount_9079 = '$9,079';
export const money_amount_200 = '-$200';
export const money_amount_700 = '-$700';
export const Payroll_March = 'Payroll March';
export const data_07_08_2020 = '07/08/2020';
export const data_07_03_2020 = '07/03/2020';
export const ATM_withdrawal = 'ATM withdrawal';
export const Direct_rent = 'Direct - rent';

// services;
export const menu_str = 'menu';
export const account_info = 'account_info';
export const send_money = 'send_money';
export const pay_bills = 'pay_bills';
export const request_payment = 'request_payment';
export const split_payment = 'split_payment';
export const top_up = 'top_up';
export const link_out = 'link_out';
export const loan = 'loan';

const getRepresentativeCategory = {
  account_info: 'Account Info',
  send_money: 'Send Money',
  pay_bills: 'Pay Bills',
  request_payment: 'Request Payment',
  split_payment: 'Split Payment',
  top_up: 'Top Up',
  link_out: 'Link Out',
  loan: 'Loan',
};

// UploadImage.js
export const menu_screenshot = 'Menu screenshot (simplified)';
export const File_type_PNG = 'File type: PNG.   File size: 1264x908 pixels.';

// Pay Bills;
// Sim_D01_PayBillsBillsList.js;
export const Bills_list_main_view = 'Bills list - main view';
export const Bills_list_scrolled_bottom = 'Bills list - scrolled to bottom';
export const bv_address_bank = 'Electric Inc.';
export const money_amount_1530 = 'R$ 1.530,29';
export const Today_str = 'Today';
export const Electricity_and_Co = 'Electricity & Co.';
export const Bill_1234567_January = 'Bill code 1234567 | January-February 2021';
export const address_Mercadopago = 'Mercadopago.com Representações Ltda';
export const money_amount_77 = 'R$ 77,87';
export const money_amount_148 = 'R$ 148.50';
export const data_10_11_2020 = '10/11/2020';
export const credit_card_es = 'Cartão de crédito';
export const Bills_list_scrolled = 'Bills list - scrolled to bottom';

// Sim_D03_PayBillsFrom.js;
export const Business_e_wallet = 'Business e-wallet';
export const credit_card_82938 = '82938-9';
export const credit_card_12345 = '12345-789';
export const money_amount_28235 = '$28,235.50';
export const num_1234_567_89 = '1234-567-89';
export const money_amount_15000 = '$15,000.00';

// Sim_D04_PayBillsConfirmation.js;
export const Confirmation_expand_details = 'Confirmation - expand details';
export const Change_payment_date = 'Change payment date';

// Sim_D06_PayBillsSuccess.js;
export const Bill_paid_100 = 'Bill paid $100';

// Sim_T01_launch_keyboard.js;
export const The_keyboard = 'The keyboard';
export const First_time_message = 'First-time message - iOS';

// Sim_T02_Auth.js;
export const Biometric_Face_ID = 'Biometric: Face ID (iOS)';
export const Biometric_Face_ID_error = 'Biometric: Face ID error';
export const Face_ID = 'Face ID';
export const Try_Again = 'Try Again';
export const Try_Face_Again = 'Try Face ID Again';
export const Biometric_Touch_ID = 'Biometric: Touch ID';
export const Touch_fingerprint_sensor = 'Touch the fingerprint sensor';
export const Biometric_Touch_ID_error = 'Biometric: Touch ID error';
export const Fingerprint_not_recognized = 'Fingerprint not recognized.\nTry again';
export const PIN_code = 'PIN code';
export const PIN_code_error = 'PIN code error';
export const OTP_one_time_password = 'OTP (one time password)';
export const OTP_error = 'OTP error';
export const Username_prefilled = 'Username pre-filled';
export const Change_ID = 'Change ID';
export const credit_card_8696 = '*******86-96';
export const Username_Password = 'Username & Password';
export const Username_Password_error = 'Username & Password error';
export const Password_is_incorrect = 'Password is incorrect, please try again';
// Request payment
export const request_reason_str = 'Weekend brunch';
// Panel_F08_RequestPaymentAmount.js
export const payment_amount = 'Payment amount';
export const Change_receiving_account = 'Change receiving account';

export const select_receiving_account = 'Select receiving account';
// Panel_F02_RequestPaymentRecipientList.js
export const contact_list = 'Contact list';
export const From_list_manually = 'From a list & manually';
export const List_only_str = 'List only';
export const Manually_only_str = 'Manually only';
export const configure_customers_select = 'Configure how customers select recipients for the payment request';
export const customer_select_recipient = 'Customer should select a recipient for the request';
export const customer_select_recipient_transfer = 'Customer should select a recipient for the transfer';
export const Skip_contact_screen = 'Skip the contact list screen when empty';
export const customer_select_recipient_list = 'Customer can select a recipient from a list';
export const add_recipient_manually_str = 'Customer can add a recipient manually\n(defined in next step)';
export const skip_contact_list = 'Skip the contact list screen when empty';
export const contact_list_design = 'Contact list design*';
export const changes_apply_contact = '*Changes apply to contact list elements in all the keyboard services';
export const reset_avatar_colors = 'Reset avatar colors';
export const allow_customers_request = 'Allow customers to add a reference for the payment request.';
export const Select_recipient_disabled_step_skipped = 'If selecting a recipient is disabled your customers won’t be asked to enter a recipient.'
    + ' This step is skipped.';

// Panel_F03_RequestPaymentTransferMethod.js
export const Select_manual_method = 'Select which manual method will be available to customers. Drag to reorder the options.';
// Panel_F10_RequestPaymentConfirmation.js
export const Payment_confirmation = 'Payment confirmation';
export const your_account = 'your_account';
export const Configure_transfer_confirmation = 'Configure the transfer confirmation screen. Most of the data is sent '
    + 'via API, and displayed as in this example.';
export const weekend_brunch_str = 'Weekend brunch';
// Panel_F12_RequestPaymentSuccess.js
export const payment_request_success = 'Payment request success';
export const enable_customers_share__bill_payment = 'Enable customers to share the bill payment';
export const enable_customers_share_payment_request = 'Enable customers to share the payment request';
export const enable_customers_go_menu = 'Enable customers to go back to menu';
export const success_image_str = 'Success image';
export const file_size_success = 'File type: PNG.  File size: 270x100 pixels at 400%.';
export const share_request_payment_button = 'share_request_payment_button';
export const enable_request_payment_back = 'enable_request_payment_back';
export const payment_request_sent = 'Payment request sent';
export const sent_text_message = 'We’ve sent a text message to the recipient with the payment request.';
export const enable_customers_share_transaction = 'Enable customers to share the transaction';
export const enable_customers_another_transaction = 'Enable customers to make another transfer';

// Panel_G02_SplitPaymentRecipientList.js
export const configure_customers_select_split = 'Configure how customers select recipients for the split payment request';
// Sim_G02_SplitPaymentRecipientsList.js
export const me_txt = 'Me';
// Sim_G10_SplitPaymentConfirmation.js
export const mum_birthday = 'Mum’s birthday';
export const total_payment = 'total_payment';
export const hundred_dollars = '$100.00';
export const thirty_four_dollars = '$34';
export const participants_dollars = 'x 3 participants';
export const show_details = 'Show details';
export const text_message_will_sent = 'A text message will be sent to participants';
// Sim_G12_SplitPaymentSuccess.js
export const split_payment_successful = 'Split payment successful!';
export const sent_text_message_split = 'We’ve sent a text message to participants with the payment request.';
export const share_split_payment_button = 'share_split_payment_button';
export const enable_split_payment_back = 'enable_split_payment_back';
export const transaction_success_default_output = 'transaction_success_default_output';
// Panel_G02_SplitPaymentConfirmParticipant.js
export const confirm_participants = 'Confirm participants';
export const where_customer_review_participants = 'This is where your customer can review participants for the split '
    + 'payment request, and remove participants on the go.';
export const amount_participant_title = 'amount_participant_title';
export const Empty_field_with_placeholder = 'Empty field with placeholder';
export const participants = 'participants';
export const participant = 'participant';
export const successInputTextPerFlow = {
  send_money: "I've just sent you money",
  account_info: "I'm just checking my balance|",
  pay_bills: "I've just paid a bill",
  request_payment: "I've requested a payment",
  split_payment: "I've split a payment",
  top_up: "I've topped up an account",
};
export const just_split_100 = "I just split $100 for Mom's Birthday among 3 people";

export const custom_reason = 'custom_reason';

// Panel_I01_LinkOut.js
export const Link_out = 'Link out';
export const Service_not_have_screens = 'This service does not have any screens, only an icon on the QAB (or menu), '
    + 'that will direct to an external URL (i.e an app/web address). ';

// steps_ordering
export const select_recipient = 'Select recipient';
export const Reference_str = 'Reference';

// Panel_E01_Deliverables.js
export const configure_which_deliverables_str = 'Configure which deliverables you wish to create';
export const iOS_options = 'iOS options';
export const Instead_accessing_redirect = '*Instead of accessing services in the keyboard, redirect the service to the bank’s app (with PayKey Go UI).';
export const Redirect_keyboard_to_bank = 'Redirect from the keyboard menu to the bank\'s app*';
export const Include_imessage = 'include iMessage extension';

// Panel_E02_UserTypes.js
export const user_type_title = 'User types';
export const user_type_paragraph = 'Configure user types with relevant services for each. Types should be written exactly as in the bank’s backend.';

// Panel_Y01_keyboardLanguage.js
export const keyboard_language_str = 'Keyboard language';
export const configure_which_languages_str = 'Configure which languages will be included in the keyboard. '
    + 'These languages will be available for your customers.';
export const language_engine_str = 'Language engine';
export const available_languages_str = 'Available languages';
export const make_default_str = 'Make default';
export const state_at_launch_str = 'State at launch';
export const dictionary_installed_str = 'Dictionary installed';
export const opened_activation_str = 'This is how the keyboard is opened at activation. Disabled Languages can be added by the customer in the settings.';
export const default_str = 'Default';
export const done_str = 'Done';
export const paykey_nlp = 'paykey_nlp';
export const search_language = 'Search a language';
export const rebit = 'rebit';
export const ota = 'ota';
export const with_keyboard = 'with_keyboard';
export const rebit_engine = 'rebit_engine';
export const paykey_engine = 'paykey_engine';
export const engineType = {
  rebit: 'Rebit',
  paykey_nlp: 'PayKey NLP',
};
export const available_languages_list = {
  id: 'Bahasa',
  en_in: 'English (IN)',
  en_gb: 'English (UK)',
  en_us: 'English (US)',
  fr: 'French',
  de: 'German',
  de_at: 'Germany',
  iw: 'Hebrew',
  ja: 'Japanese (iOS-only)',
  kk_kz: 'Kazakh',
  kk: 'Kazakh',
  km: 'Khmer',
  ko: 'Korean (Hangul)',
  pl: 'Polish',
  pt_br: 'Portuguese (Brazil)',
  pt: 'Portuguese (European)',
  ro: 'Romanian',
  ru: 'Russian',
  sk: 'Slovak',
  es_419: 'Spanish (Latin America)',
  es_us: 'Spanish (Latin America)',
  zh_hk: 'Traditional Chinese (Handwriting) (Android-only)',
  zh_tw: 'Traditional Chinese (Zhuyin)',
};
export const dictionary_installed_list = {
  ota: 'OTA(Over the air,to device)',
  with_keyboard: 'With keyboard(in SDK)',
};
export const dictionary_installed_list_keys = {
  ota: 'OTA',
  with_keyboard: 'With keyboard',
};
// Panel_Y02_keyboardPromotion.js
export const Promotion_str = 'Promotion';
export const promotion_configure_section = 'Configure a promotion section in the keyboard, available through the quick action bar.';
export const Enable_promotion_switch = 'Enable a promotion section in the keyboard';
export const promotion_cards_str = 'Promotion cards';
export const send_promotion_section = 'Send promotions dynamically via API, including a placeholder for loading and connectivity issues.';
export const promotion_file_details = 'File size: 260 x 233 pixels (this size is @1x).';
export const Empty_state_image_str = 'Empty state image';
export const promotion_file_type = 'File type: PNG.  File size: 1080 x 600 pixels (@4x).';
export const qab_icon = 'qab_icon';

// Panel_Y03_keyboardSaveTypingData.js
export const save_typing_data_str = 'Save typing data';
export const configure_if_to_save_str = 'Configure if to save customers’ typing data from the keyboard. Data will be anonymised and then stored.';

// Panel_Z01_send_form.js
export const bank_keyboard = 'bank_keyboard';
export const send_form_title = 'Create an app SDK';
export const send_form_paragraph = 'Update this configuration in Firebase & Bitrise and create a new SDK version. \n\n'
    + 'Make sure the bank’s configuration, assets and text elements are up to date.';
export const send_form_text = 'Your downloads';
export const publish_button = 'Publish';
export const create_button = 'Create SDK';
export const select_button = 'Select';
export const Activity_str = 'Activity';
export const Updated_str = 'Updated';
export const Published_str = 'Published';
export const SDK_str = 'SDK';
export const download_options = {
  android_image_files: 'Android Image files',
  android_other_files: 'Android Other files',
  iOS_Image_files: 'iOS Image files',
  iOS_Other_files: 'iOS Other files',
  Android_onboarding: 'Android onboarding',
  iOS_onboarding: 'iOS onboarding',
};
export const uploading_send_popup = (bank_name) => `Uploading ️${bank_name} 🔜☁️`;
export const create_send_popup = (bank_name) => `Creating SDK for ️${bank_name} 🔜☁️`;
export const finished_send_popup = (bank_name, version) => `Finished successfully ${bank_name} - v️${version} ✅`;
export const failed_send_popup = (bank_name, version) => `Failed to create ${bank_name} - v️${version} ❌`;

// Icons;
export const bank_logo = 'bank_logo';
export const iMsg_bank_logo = 'iMsg_bank_logo';
export const icon_action_bar = 'icon_action_bar';
export const imsg_bank_logo = 'imsg_bank_logo';
export const verify_recipient_icon = 'verify_recipient_icon';
export const img_arrow_right_button = 'img_arrow_right_button';
export const general_error_icon = 'general_error_icon';
export const no_connection_icon = 'no_connection_icon';
export const transaction_failed_icon = 'transaction_failed_icon';
export const permission_to_photos = 'permission_to_photos_icon';
export const no_landscape_icon = 'no_landscape_icon';
export const success_image = 'success_image';
export const imsg_expand_title = 'imsg_expand_title';
export const imsg_expand_button = 'imsg_expand_button';
export const no_results_image = 'no_results_image';
export const keyboard_logo = 'keyboard_logo';
export const company_logo = 'company_logo';
export const kbd_announcement_icon = 'kbd_announcement_icon';
export const kbd_come_back_icon = 'kbd_come_back_icon';
export const kbd_success_icon = 'kbd_success_icon';
export const onboarding_small_stickers = 'onboarding_small_stickers';
export const onboarding_big_stickers = 'onboarding_big_stickers';
export const example_one = 'Example 1';
export const example_Two = 'Example 2';
export const splash_screen_one = 'Splash screen 1: Intro';
export const splash_screen_two = 'Splash screen 2: Main services';
export const splash_screen_three = 'Splash screen 3: Security';
export const splash_screen_Stickers = 'Splash screen 3: Stickers & GIFs';

export const user = 'user';
export const Customer = 'Customer';
export const Paykey = 'Paykey';

export const onboardingImagesNames = {
  ic_onboarding_intro: 'ic_onboarding_intro',
  ic_activation_success: 'ic_activation_success',
  ic_onboarding_typing_experience: 'ic_onboarding_typing_experience',
  ic_onboarding_services: 'ic_onboarding_services',
  ic_android_enable_keyboard: 'ic_android_enable_keyboard',
  ic_android_select_keyboard: 'ic_android_select_keyboard',
  ic_onboarding_security: 'ic_onboarding_security',
  ic_onboarding_media: 'ic_onboarding_media',
  ic_ios_come_back: 'ic_ios_come_back',
  ic_ios_select_keyboard: 'ic_ios_select_keyboard',
  ic_activation_start_arrow: 'ic_activation_start_arrow',
};

export const keyboardImagesNames = {
  ic_keyboard: 'ic_keyboard',
  qab_menu_bank_logo: 'qab_menu_bank_logo',
  ic_keyboard_disabled: 'ic_keyboard_disabled',
  ic_bank_logo: 'ic_bank_logo',
  ic_iMsg_bank_logo: 'ic_imsg_bank_logo',
  ic_no_results: 'ic_no_results',
  ic_verify_recipient: 'ic_verify_recipient',
  ic_general_error: 'ic_general_error',
  ic_connection_error: 'ic_connection_error',
  ic_transaction_error: 'ic_transaction_error',
  ic_gallery_permission: 'ic_gallery_permission',
  ic_landscape_error: 'ic_landscape_error',
  ic_empty_view_state: 'ic_empty_view_state',
  ic_success: 'ic_success',
  wls_ic_add_recipient_plus: 'wls_ic_add_recipient_plus',
  wls_ic_add_recipient_contact: 'wls_ic_add_recipient_contact',
  wls_ic_search_arrow: 'wls_ic_search_arrow',
  wls_ic_search_magnify: 'wls_ic_search_magnify',
};

export const getTooltipsTitleTag = {
  colors: 'Colors',
  radius: 'Radius',
  fonts: 'Fonts',

  recipient: 'Select contacts',
  amount: 'Amount',
  number: 'Number',
  source: 'Source',
  option: 'Option',
  reference: 'Reference',
  confirmation: 'Confirmation',
  success: 'Success',
  amount_package: 'Amount',
  operator: 'Select Operator',
  balance: 'Balance',
  transactions: 'In and Out',
  select_bill: 'Bills list',
  confirmation_bill: 'Confirmation',
  confirmation_split: 'Confirmation',
  deliverables: 'Deliverables',
  user_types: 'User Types',
  keyboard: 'Keyboard',
  auth: 'Authentication',
  error_messages: 'Errors',
  empty_state: 'Empty state',
  expand_message: 'Expand Message',

  announcement: 'Announcement',
  promotion: 'Promotion',
  instructions: 'Instructions',
};

export const getSubCategoryId = (service) => `${service.sub_category}_${service.duplication_number}`;

export const getRepresentativeKey = (service) => `${getRepresentativeCategory[service.sub_category]} ${service.duplication_number || ''}`;

export const getRepresentativeKeyId = (serviceId) => `${getRepresentativeCategory[getSubCategory(serviceId)]}${getDuplicationNumber(serviceId) || ''}`;

export const getSubCategory = (subCategoryId) => subCategoryId.slice(0, -2);

export const getDuplicationNumber = (serviceId) => parseInt(serviceId.slice(-1), 10);

export const getAvatarColor = (index) => `avatar_color_${index}`;

export const getStringXMLName = (flowCode) => `strings-${flowCode}.xml`;

export const getConfigXMLName = (subCategoryId) => `go_${subCategoryId}_flow_config`;

export const getManualDetailsKey = (manualName) => `enter_details_${manualName}`;

export const addPathToList = (listStrings, baseDir) => listStrings.map((str) => baseDir + str);
